import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';
import BrandButton from '../brandButton/BrandButton';

const UpgradeBanner = ({ onUpgrade }) => {
    return (
        <Box
            w="100%"
            bg="brand.primary"
            borderRadius="10px"
            p={5}
            mb={6}
            boxShadow="0 2px 8px rgba(19, 74, 112, 0.15)"
        >
            <Flex
                direction={{ base: 'column', md: 'row' }}
                align={{ base: 'flex-start', md: 'center' }}
                justify="space-between"
                gap={4}
            >
                <Flex align="center" gap={3} flex={1}>
                    <LockIcon color="white" boxSize={6} />
                    <Box>
                        <Text fontSize="18px" fontWeight={600} color="white" mb={1}>
                            Upgrade to Starter or Pro plan to unlock full investor details
                        </Text>
                        <Text fontSize="14px" color="rgba(255, 255, 255, 0.9)" lineHeight="1.5">
                            Get access to biography, past investments, check size, preferred sectors, and contact channels
                        </Text>
                    </Box>
                </Flex>
                <Box flexShrink={0}>
                    <BrandButton
                        text="Upgrade"
                        onClick={onUpgrade}
                        colorScheme="white"
                        bg="white"
                        color="#134A70"
                        fontSize="15px"
                        width="auto"
                        px={6}
                        py={2}
                        borderRadius="6px"
                    />
                </Box>
            </Flex>
        </Box>
    );
};

export default UpgradeBanner;

